<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Employee Branding</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                color="primary"
                class="float-left mb-2 ml-3"
                @click="createEmployeeBranding"
                >Create</CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                    class="float-left mb-0 mr-2"
                    placeholder="Search by Name"
                    v-model="request.q"
                    @input="onSearch()"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
            hover
            striped
            :items="items"
            :fields="fields"
            :items-per-page="10"
            clickable-rows
            :active-page="1"
            :pagination="{ doubleArrows: false, align: 'center' }"
          >
            <template #employee_branding_action="data">
              <td>
                <div class="button-table">
                  <CButton
                    color="primary"
                    class="mb-0 mr-0"
                    @click="editEmployeeBranding(data.item.id)"
                    >Edit</CButton
                  >
                </div>
              </td>
            </template>
            <template #testimonial="data">
              <td>
                <div style="width: 350px;" v-html="data.item.testimonial" />
              </td>
            </template>
            <template #attachment_employee_branding_photo_url="data">
              <td>
                <img :src="data.item.attachment_employee_branding_photo_url" width="74.6px" :alt="data.item.employee_name">
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
              class="pagination-btn-refresh"
              @click="getEmployeeBrandingList('REFRESH')"
            >
              Refresh
            </div>
            <div class="pagination-btn-back" @click="getEmployeeBrandingList('BACK')">
              back
            </div>
            <div class="pagination-page-title">{{ request.page }}</div>
            <div class="pagination-btn-next" @click="getEmployeeBrandingList('NEXT')">
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import CareerUseCase from '../app/usecase/career';
import mixins from '../misc/mixins';

export default {
  name: "EmployeeBranding",
  mixins: [mixins],
  data() {
    return {
      items: [],
      fields: [
        {key: 'attachment_employee_branding_photo_url', label: 'Gambar'},
        {key: 'testimonial', label: 'Deskripsi Testimonial'},
        {key: 'employee_name', label: 'Nama'},
        {key: 'employee_position', label: 'Posisi'},
        {key: 'status', label: 'Status'},
        {key: 'priority', label: 'Priority'},
        {key: 'employee_branding_action', label: 'Action'},
      ],
      request: {
        page: 1,
        per_page: 10,
        q: ""
      },
      debounce: {
        timeout: 0,
        duration: 500,
      },
      searchTimout: null
    }
  },
  mounted() {
    this.getEmployeeBrandingList()
  },
  beforeDestroy() {
    clearTimeout(this.searchTimout)
  },
  methods: {
    async getEmployeeBrandingList(action) {
      try {
        this.validatePagination(action);
        const queryString = Object.keys(this.request)
          .map((key) => key + "=" + this.request[key])
          .join("&");
        const { data, err } = await CareerUseCase.getAll(queryString);
          if (err || data.data.length == 0) {
            this.validateNextPagination(action);
            this.err = err;
          }else {
          if (data) {
            window.scrollTo(0, 0);
            this.items = data.data.map((item) => ({...item, priority: item.priority || '-'}));
          }
        }
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
      }
    },
    async searchEmployeeBranding() {
      try {
        await this.getEmployeeBrandingList()
        this.request.page = 1
      } catch (err) {
        await this.$swal.fire({
          icon: "error",
          text: err
        })
      }
    },
    onSearch() {
      clearTimeout(this.searchTimout)
      this.searchTimout = setTimeout(this.searchEmployeeBranding, this.debounce.duration);
    },
    validatePagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page + 1;
      } else if (action === "BACK") {
        if (this.request.page > 1) {
          this.request.page = this.request.page - 1;
        }
      } else if (action === "REFRESH") {
        this.request.page = 1;
      } else {
        this.request.page = 1;
      }
    },
    validateNextPagination(action) {
      if (action === "NEXT") {
        this.request.page = this.request.page - 1;
      } else {
        this.items = [];
      }
    },
    editEmployeeBranding(id) {
      this.$router.push({ path: `/career/employee-branding/${id}` })
    },
    createEmployeeBranding() {
      this.$router.push({ path: '/career/employee-branding/create' })
    }
  }
}

</script>
<style scoped>
@import "../applicants/Applicant.css";
</style>
